export const getIsPhysicalBatteryEnabled = () => {
  return String(import.meta.env.VITE_FF_PHYSICAL_BATTERY).toLowerCase() === 'true';
};

export const getIsPreloadedBatteryOfferEnabled = () => {
  return String(import.meta.env.VITE_FF_PRELOADED_BATTERY_OFFER).toLowerCase() === 'true';
};
